<template>
  <div
    class="frisbuy-fully-widget-container"
    @click.self="() => onBlurHandler()"
    v-touch:swipe="(direction: TSwipe) => onSwipeHandler(direction)"
  >
    <div class="frisbuy-fully-widget-container__close-button-wrapper">
      <slot name="closeButton">
        <button
          class="frisbuy-fully-widget-container__close-button"
          @click="$emit('close')"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.6077 6.29437C17.2138 5.90724 16.5807 5.91272 16.1936 6.3066L11.9878 10.5857L7.70878 6.38003C7.31489 5.9929 6.68175 5.99838 6.29462 6.39227C5.90748 6.78615 5.91296 7.4193 6.30685 7.80643L10.5859 12.0121L6.38006 16.2914C5.99293 16.6852 5.9984 17.3184 6.39229 17.7055C6.78618 18.0926 7.41932 18.0872 7.80645 17.6933L12.0123 13.414L16.2916 17.6199C16.6855 18.0071 17.3186 18.0016 17.7058 17.6077C18.0929 17.2138 18.0874 16.5807 17.6935 16.1935L13.4142 11.9876L17.6199 7.70853C18.0071 7.31465 18.0016 6.6815 17.6077 6.29437Z"
              fill="#999999"
            />
          </svg>
        </button>
      </slot>
    </div>

    <div
      class="frisbuy-fully-widget-container__content-wrapper"
      ref="contentWrapper"
      @scroll="(e) => scrollHandler(e)"
    >
      <div class="frisbuy-fully-widget-container__content-wrapper-inner">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  defineEmits,
  onBeforeUnmount,
  onMounted,
  ref,
} from "vue";
import { TSwipe } from "../../globals";

const emit = defineEmits<{
  close: [];
}>();

onMounted(() => {
  lockWindowScroll();
});

onBeforeUnmount(() => {
  unlockWindowScroll();
});

function onBlurHandler() {
  emit("blur");
}

function lockWindowScroll() {
  document.documentElement.style.overflow = "hidden";
}

function unlockWindowScroll() {
  document.documentElement.style.overflow = "";
}

function onSwipeHandler(direction: TSwipe) {
  emit("swipe", direction);
}

const contentWrapper = ref<HTMLElement | null>(null);

function scrollHandler(e: Event) {
  const target = e.target as HTMLElement;
  const scrollTop = target.scrollTop;

  // Scroll position event
  const scrollBottom = target.scrollHeight - (target.offsetHeight + scrollTop);
  emit("scroll", {
    top: scrollTop,
    bottom: scrollBottom,
  });
}

</script>

<style lang="scss">
@import "@/widgets/MarketplaceReviews/mixins.scss";
.frisbuy-fully-widget-container {
  &,
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    text-decoration: none;
    list-style: none;

    box-sizing: border-box;
  }

  // display: flex;
  // align-items: center;
  // justify-content: center;
  position: fixed;
  inset: 0;

  width: 100dvw;
  height: 100dvh;

  background-color: #ffffff;

  overflow: hidden;

  z-index: 100;

  .frisbuy-fully-widget-container__close-button-wrapper {
    position: absolute;
    top: 0;
    right: max(12px, env(safe-area-inset-right));
    width: 40px;
    height: 40px;
    cursor: pointer;
    z-index: 3;

    .frisbuy-fully-widget-container__close-button {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 40px;
      height: 40px;

      background: transparent;
      outline: none;
      border: none;
      cursor: pointer;

      border-radius: 4px;

      z-index: 1;

      svg {
        display: block;
      }
    }
  }

  .frisbuy-fully-widget-container__content-wrapper {
    display: block;
    position: relative;
    height: 100%;
    width: 100%;
    overflow: auto;

    padding: 72px 0 80px;
    margin: 0 auto;

    @media screen and (max-width: 1024px) {
      margin: 40px 0 0;
      height: calc(100% - 104px);
      padding: 0;
    }
  }

  .frisbuy-marketplace-reviews__customers-photos-title {
    margin: 0 0 24px;
  }

  .frisbuy-product-rating {
    display: flex;
    position: relative;
    justify-content: space-between;
    flex-direction: column;

    margin-top: 32px;
  }

  .frisbuy-fully-widget-container__content-wrapper-inner {
    max-width: 1288px;
    margin: 0 auto;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;

    @media screen and (max-width: 1440px) {
      max-width: 944px;
    }
    @media screen and (max-width: 1024px) {
      max-width: unset;

      .frisbuy-marketplace-reviews__product-raiting {
        display: none;
      }
    }
  }
}

// media queries
@media screen and (max-width: $size-s) {
  .frisbuy-fully-widget-container {
    .frisbuy-fully-widget-container__close-button-wrapper {
      max-width: $size-xs;
      background-color: #ffffff;

      margin: 0 auto;

      .frisbuy-fully-widget-container__close-button {
        background-color: rgba(255, 255, 255, 0.8);

        margin-right: 18px;

        // svg {
        //   mix-blend-mode: difference;

        //   path {
        //     fill: #ffffff;
        //   }
        // }
      }
    }
  }
}

</style>
